import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';

import './style.less';
import img1 from '../../static/images/anniversary/01.jpg';
import img2 from '../../static/images/anniversary/02.jpg';
import img3 from '../../static/images/anniversary/03.jpg';
import img4 from '../../static/images/anniversary/04.png';

class anniversaryPage extends Component {
    render(){
        return(
            <DocumentTitle title={'周年庆'}>
                <div className="container anniversary">
                    <img src={img1} alt="爱课周年庆"/>
                    <img src={img2} alt="爱课周年庆"/>
                    <img src={img3} alt="爱课周年庆"/>
                    <img src={img4} alt="爱课周年庆"/>
                </div>
            </DocumentTitle>
        )
    }
}

export default anniversaryPage;



// WEBPACK FOOTER //
// ./src/components/anniversaryPage/anniversary.jsx